// Inicis mobile web payment (모바일 웹표준).
//
// The PC INIStdPay window refuses to run on phones ("해당기기로는 정상적인
// 결제가 진행되지 않을 수 있습니다. PC로 결제 진행을 부탁드립니다"), so on
// mobile browsers we post Inicis's mobile payment form instead. Inicis then
// calls the backend's /api/inicis/mobile-return (P_NEXT_URL), which requests
// the final approval and redirects to /payment/success — the exact page the
// PC flow already lands on, so PaymentSuccess needs no changes.

export const isMobileDevice = () =>
  /Android|iPhone|iPad|iPod|Windows Phone|webOS|BlackBerry/i.test(
    navigator.userAgent
  );

// Full-page form POST to the Inicis mobile payment window. `pay` is the
// response of /inicis/prepare merged with goodname/buyername/buyertel/buyeremail
// (the same object handed to the PC flow).
export const startMobileInicisPayment = (pay) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = "https://mobile.inicis.com/smart/payment/";

  const fields = {
    P_INI_PAYMENT: "CARD",
    P_MID: pay.mid,
    P_OID: pay.oid,
    P_AMT: pay.price,
    P_GOODS: pay.goodname,
    P_UNAME: pay.buyername,
    P_MOBILE: pay.buyertel || "01000000000",
    P_EMAIL: pay.buyeremail || "",
    P_CHARSET: "utf8",
    P_NEXT_URL: `${window.location.origin}/api/inicis/mobile-return`,
    P_RESERVED: "below1000=Y&centerCd=Y",
  };

  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value == null ? "" : String(value);
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
};
